cmsForm2022.prototype.setTimezone = function(timezone){
  this.config.timezone = timezone;
};

cmsForm2022.prototype.timeFields = function(){
  var fields = this.form.querySelectorAll(".timeField");
  for(let f of fields){
    if(f.querySelector("input")){
      continue;
    }

    var label = document.createElement("label");
    label.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Time</title><path d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M256 128v144h96"/></svg>';
    var span = document.createElement("span");

    span.innerHTML = f.getAttribute("data-label");

    span.innerHTML += " ("+moment.tz(this.config.timezone).zoneAbbr()+")";
    if(f.getAttribute("data-required")){
      span.innerHTML = span.innerHTML + " <div class='requiredLabel'>*</div>";
    }
    label.append(span);
    var input = document.createElement("input");
    input.setAttribute("type","hidden");
    input.classList.add("timeFieldInput");
    input.setAttribute("name",f.getAttribute("data-name"));
    if(f.getAttribute("data-required")){
      input.setAttribute("data-required","true");
    }

    var timeValue = document.createElement("div");
    timeValue.classList.add("timeValue");
    timeValue.innerHTML = f.getAttribute("data-placeholder") || "Choose a Time";


    label.append(input);
    label.append(timeValue);
    f.append(label);

    label.classList.add("withLabel");

    this.timePickerField = f;
    if(f.getAttribute("data-value")){
      var value = parseInt(f.getAttribute("data-value"));

      var dateObj = new Date();
      dateObj.setTime(value);
      var hour = dateObj.getUTCHours();
      var minutes = dateObj.getUTCMinutes();


      var timestamp = 0;
      // Add Hours:
      timestamp += (hour*60)*60;

      // Add Minutes
      timestamp += (parseInt(minutes))*60;

      // Convert to Miliseconds
      timestamp = timestamp * 1000;



      this.timePickerSetTime(timestamp);
    }

    f.addEventListener("click",(e)=>{
      e.preventDefault();
      this.timePickerField = e.currentTarget;
      this.timeFieldPicker();
    });
  }
};



cmsForm2022.prototype.timeFieldPicker = function(){
  if(this.timePickerScreen) return;

  var timePickerValue = this.timePickerField.querySelector("input").value;
  var currentValue = false;
  var currentValueHour = false;

  if(timePickerValue && timePickerValue !== ""){
      currentValue = new Date();
      currentValue.setTime(timePickerValue);



      currentValueHour = parseInt(currentValue.getUTCHours());
      if(currentValueHour >= 24){
        currentValueHour = currentValueHour - 24;
      }
      var currentValueHour24 = currentValueHour;

      currentValueHour = currentValueHour > 12 ? currentValueHour - 12 : currentValueHour;
  }

  var dateObj = new Date();

  var timestamp = this.timePickerField.querySelector("input").value;
  if(timestamp && timestamp !== ""){
    dateObj.setTime(timestamp);
  }

  this.timePickerScreen = document.createElement("div");
  this.timePickerScreen.classList.add("timePicker");

  var holder = document.createElement("div");
  holder.classList.add("timePickerHolder");
  this.timePickerScreen.append(holder);

  var label = document.createElement("h3");
  label.innerText = this.timePickerField.getAttribute("data-label") || "";
  holder.append(label);

  var hourInput = document.createElement("select");
  hourInput.classList.add("hourSelect");

  Array.from({length:12},(v,k)=>k+1).forEach(hour=>{
    var option = document.createElement("option");

    if(currentValueHour !== false && currentValueHour == hour){
      option.selected = "selected";
    }
    else if(currentValueHour == 0 && hour == 12){
      option.selected = "selected";
    }
    var hourString = hour;
    if(hourString < 10){
      var hourString = "0"+hourString;
    }
    option.value = hour;
    option.innerText = hourString;
    hourInput.append(option);
  });

  var minuteInput = document.createElement("select");
  minuteInput.classList.add("minuteSelect");

  Array.from({length:60},(v,k)=>k).forEach(minute=>{
    var option = document.createElement("option");
    if(currentValue && currentValue.getUTCMinutes() == minute){
      option.selected = "selected";
    }
    if(minute < 10){
      minute = "0"+minute;
    }
    option.value = minute;
    option.innerText = minute;



    minuteInput.append(option);
  });

  minuteInput.setAttribute("id","timePickerMinuteSelect");
  hourInput.setAttribute("id","timePickerHourSelect");



  var suffixHolder = document.createElement("div");
  suffixHolder.classList.add("suffixSelect");

  var suffixAM = document.createElement("div");
  suffixAM.classList.add("option");



  suffixAM.innerText = "AM";
  suffixAM.setAttribute("data-value","am");


  var suffixPM = document.createElement("div");
  suffixPM.classList.add("option");

  suffixPM.innerText = "PM";
  suffixPM.setAttribute("data-value","pm");



  suffixHolder.append(suffixAM);
  suffixHolder.append(suffixPM);

  if(currentValue && currentValueHour24){
    //var utcStart = new Date(1970,0,1);
    //var relativeTime = currentValue.getTime() - utcStart.getTime();
    if(currentValueHour24 < 12){
      suffixAM.classList.add("selected");
    }
    else{
      suffixPM.classList.add("selected");
    }
  }
  else{
    suffixAM.classList.add("selected");
  }

  var inputHolder = document.createElement("div");
  inputHolder.classList.add("inputHolder");
  var separator = document.createElement("div");
  separator.innerHTML = ":";
  separator.classList.add("separator");

  inputHolder.append(hourInput);
  inputHolder.append(separator);
  inputHolder.append(minuteInput);
  inputHolder.append(suffixHolder);

  holder.append(inputHolder);



  var submitButton = document.createElement("button");
  submitButton.innerText = "Set Time";


  var setTime = (close = false) => {
    var selectedSuffix = this.timePickerScreen.querySelector(".suffixSelect .option.selected").getAttribute("data-value");
    var minutes = (minuteInput.value);

    var hour = parseInt(hourInput.value);
    if(selectedSuffix == "am" && hour == 12){
      hour = 0;
    }
    else if(selectedSuffix == "pm" && hour == 12){
      hour = 12;
    }
    else if(selectedSuffix == "pm"){
      hour = hour + 12;
    }




    var input = this.timePickerField.querySelector("input");
    var display = this.timePickerField.querySelector(".timeValue");

    //relativeTime = (((hour+offset)*60)+(parseInt(minuteInput.value)*60)*1000;
    relativeTime = 0;

    var timestamp = 0;
    // Add Hours:
    timestamp += (hour*60)*60;

    // Add Minutes
    timestamp += (parseInt(minuteInput.value))*60;

    // Convert to Miliseconds
    timestamp = timestamp * 1000;


    input.value = timestamp;
    this.timePickerField.setAttribute("data-value",timestamp);


    display.innerHTML = this.timeFieldValue(timestamp);

    if(close){
      this.timePickerScreen.remove();
      this.timeHourPopupSelect.remove();
      this.timeMinutePopupSelect.remove();
      this.timePickerScreen = false;
    }

  }

  submitButton.addEventListener("click",(e)=>{
    e.preventDefault();
    setTime(true);
  });

  hourInput.addEventListener("change",(e)=>{
    e.preventDefault();
    setTime();
  });

  minuteInput.addEventListener("change",(e)=>{
    e.preventDefault();
    setTime();
  });

  suffixAM.addEventListener("click",(e)=>{
    e.currentTarget.classList.add("selected");
    suffixPM.classList.remove("selected");
    setTime();
  });

  suffixPM.addEventListener("click",(e)=>{
    e.currentTarget.classList.add("selected");
    suffixAM.classList.remove("selected");
    setTime();
  });

  inputHolder.append(submitButton);








  this.timePickerScreen.addEventListener("click",(e)=>{
    if(e.target !== e.currentTarget) return;
    this.timePickerScreen.remove();
    this.timeHourPopupSelect.remove();
    this.timeMinutePopupSelect.remove();
    this.timePickerScreen = false;
  })

  this.form.append(this.timePickerScreen);

  this.timeHourPopupSelect = new inlineSelect("timePickerHourSelect",{
    showClass:"show",
    title:"Hour:",
    optionAppend:":",
    onChange:()=>{
      setTime();
    }
  });

  this.timeMinutePopupSelect = new inlineSelect("timePickerMinuteSelect",{
    showClass:"show",
    title:"Minute:",
    optionPrepend:":",
    onChange:()=>{
      setTime();
    }
  });


};

cmsForm2022.prototype.timePickerSetTime = function(timestamp){
  this.timePickerField.querySelector("input").value = timestamp;
  var display = this.timePickerField.querySelector(".timeValue");
  display.innerHTML = this.timeFieldValue(timestamp);
};


cmsForm2022.prototype.timeFieldValue = function(timestamp=new Date().getTime()){
  var theDate = new Date();
  theDate.setTime(timestamp);
  var timestamp_seconds = timestamp/1000;
  var hour = timestamp_seconds/60;
  var minutes = hour/60;

  var suffix = "am";
  var hourString = theDate.getUTCHours();
  var minuteString = theDate.getUTCMinutes();

  if(hourString == 0){
    hourString = 12;
  }
  else if(hourString == 12){
    suffix = "pm";
  }
  else if(hourString > 12){
    hourString = hourString - 12;
    suffix = "pm";
  }

  if(minuteString < 10){
    minuteString = "0" + minuteString;
  }

  return hourString + ":" + minuteString + " "+suffix;

}
